/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SearchLoupeIcon32Regular = forwardRef('SearchLoupeIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 2.5C8.096 2.5 2.5 8.096 2.5 15S8.096 27.5 15 27.5a12.45 12.45 0 0 0 8.104-2.982l6.189 6.19a1 1 0 0 0 1.414-1.415l-6.19-6.19A12.45 12.45 0 0 0 27.5 15c0-6.904-5.596-12.5-12.5-12.5ZM4.5 15C4.5 9.201 9.201 4.5 15 4.5S25.5 9.201 25.5 15 20.799 25.5 15 25.5 4.5 20.799 4.5 15Z" })));
});
